import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { XeroDataStore } from '../xero-data.store';
import { Observable } from 'rxjs';
import { XeroAccount } from '../xero-account.model';
import {
  XERO_INTEGRATION_ROUTE,
  XERO_INTEGRATION_SETUP_ROUTE,
  XERO_SETTINGS_ROUTE,
} from '../../xero/xero.constant';
import { XeroAccountStatusEnum } from '../xero-data.data';
import { NavigationService } from '../../navigation/navigation.service';
import { Injectable } from '@angular/core';
import { SETTINGS_ROUTE } from '../../main/main.data';
import { SETTINGS_XERO_ROUTE } from '../../settings/settings.data';
import { map } from 'rxjs/operators';

@Injectable()
export class XeroGuard implements CanActivate {
  constructor(
    private _xeroDataStore: XeroDataStore,
    private _navigationService: NavigationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._xeroDataStore.getXeroAccount().pipe(
      map(({ status }: XeroAccount) => {
        let isAllowedAccess: boolean;
        let redirectRoute: string;

        switch (status) {
          case XeroAccountStatusEnum.AUTHORIZED:
            isAllowedAccess =
              route.routeConfig.path === XERO_INTEGRATION_SETUP_ROUTE;
            redirectRoute = XERO_INTEGRATION_SETUP_ROUTE;
            break;
          case XeroAccountStatusEnum.INTEGRATED:
            isAllowedAccess = route.routeConfig.path === XERO_SETTINGS_ROUTE;
            redirectRoute = XERO_SETTINGS_ROUTE;
            break;
          case XeroAccountStatusEnum.UNAUTHORIZED:
          default:
            isAllowedAccess = route.routeConfig.path === XERO_INTEGRATION_ROUTE;
            redirectRoute = XERO_INTEGRATION_ROUTE;
            break;
        }

        if (!isAllowedAccess) {
          this._navigationService.goTo([
            SETTINGS_ROUTE,
            SETTINGS_XERO_ROUTE,
            redirectRoute,
          ]);
        }
        return isAllowedAccess;
      })
    );
  }
}
